module.exports = __webpack_public_path__ + "img/gill-foundation-logo.2bcd52d6.png";